import { createAction } from '@reduxjs/toolkit';

import * as ActionTypes from './actionTypes';

export const setFileAction = createAction(ActionTypes.SET_FILE_ACTION.BASE);
